import React from 'react';
import { Navigate } from 'react-router-dom';
import { LongevityPackBuilder } from '../components/LongevityPackBuilder';
import { PackSummary } from '../components/PackSummary';
import { PageHeader } from '../components/PageHeader';
import { PregnancyPlanPicker } from '../components/PregnancyPlanPicker';
import { usePlatform } from '../contexts/PlatformContext';
export function Plan() {
  const {
    goal
  } = usePlatform();
  if (!goal) return <Navigate to="/profile" replace data-id="element-203" data-mp="16d2g9mjyfmco" />;
  const isPregnancy = goal === 'pregnancy';
  return <div data-id="element-204" data-mp="1bauain82nkk1">
      <PageHeader eyebrow="Recommendation" title={isPregnancy ? 'Choose your pregnancy plan' : 'Build your wellbeing pack'} description={isPregnancy ? "We've recommended the plan for your stage. Each one is tuned to your results — switch if your stage changes." : 'Based on your biomarkers, these are the supplements we suggest. Add or remove to make it yours.'} data-id="element-205" data-mp="1bei2hhxvbywn" />
      <div className="mt-10 grid gap-8 lg:grid-cols-[1fr_320px]" data-id="element-206" data-mp="2foxxpvu08tob">
        {isPregnancy ? <PregnancyPlanPicker data-id="element-207" data-mp="2axpnixkup4a3" /> : <LongevityPackBuilder data-id="element-208" data-mp="2ax68boml4tzr" />}
        <PackSummary data-id="element-209" data-mp="2aw4u5ba9vrdt" />
      </div>
    </div>;
}